/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThoughtspotDataSource } from './ThoughtspotDataSource';
import {
    ThoughtspotDataSourceFromJSON,
    ThoughtspotDataSourceFromJSONTyped,
    ThoughtspotDataSourceToJSON,
    ThoughtspotDataSourceToJSONTyped,
} from './ThoughtspotDataSource';

/**
 * 
 * @export
 * @interface GetThoughtspotDataSourcesResponse
 */
export interface GetThoughtspotDataSourcesResponse {
    /**
     * 
     * @type {Array<ThoughtspotDataSource>}
     * @memberof GetThoughtspotDataSourcesResponse
     */
    data: Array<ThoughtspotDataSource>;
}

/**
 * Check if a given object implements the GetThoughtspotDataSourcesResponse interface.
 */
export function instanceOfGetThoughtspotDataSourcesResponse(value: object): value is GetThoughtspotDataSourcesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetThoughtspotDataSourcesResponseFromJSON(json: any): GetThoughtspotDataSourcesResponse {
    return GetThoughtspotDataSourcesResponseFromJSONTyped(json, false);
}

export function GetThoughtspotDataSourcesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetThoughtspotDataSourcesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ThoughtspotDataSourceFromJSON)),
    };
}

export function GetThoughtspotDataSourcesResponseToJSON(json: any): GetThoughtspotDataSourcesResponse {
    return GetThoughtspotDataSourcesResponseToJSONTyped(json, false);
}

export function GetThoughtspotDataSourcesResponseToJSONTyped(value?: GetThoughtspotDataSourcesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ThoughtspotDataSourceToJSON)),
    };
}

